import createAxios from '../axiosHttp';

function getEntitiesNotRegistered() {
    const axios = createAxios();
    let urlPath = `/administration/dashboard/entities-not-registered`;
    return axios.get(urlPath);
}
function getEntityAsExcel(filters,entity){
    const axios = createAxios();
    let urlPath = `administration/dashboard/entity/report?limit=5000&entity=${entity}`;
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}
function getQueuesError(filters) {
    const axios = createAxios();
    let urlPath = `/administration/dashboard/queues-error?`;
    if (filters && filters.date.start) {
        urlPath += `start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    return axios.get(urlPath);
}
export const dashboardAdminService = {
    getEntitiesNotRegistered,getEntityAsExcel,getQueuesError
};